import { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { stripSpecialChars } from 'helpers';
import NotificationSignup from 'components/landing/NotificationSignup.jsx';
import LandingPageImage from 'components/landing/LandingPageImage';
import LandingPageLink from 'components/landing/LandingPageLink';

import css from 'styles/components/landing/melodyPromoGroup.scss';

const makeKey = (prefix, suffix) => `${stripSpecialChars(prefix)}_${suffix}`;

export class MelodyPromoGroup extends Component {

  state = {
    modalIndex: null
  };

  toggleModal = e => {
    const i = e.target.dataset?.modalIndex;
    this.setState({ modalIndex: +i });
    const { onLandingComponentClick } = this.props;
    onLandingComponentClick(e);
  };

  render() {
    const { modalIndex } = this.state;
    const { slotName, slotIndex, slotDetails, onLandingComponentClick, shouldLazyLoad } = this.props;
    const { testId } = this.context;
    const { promos, heading, monetateId, variant } = slotDetails;
    const exactlyTwoPromos = promos.length === 2;
    const isCenterAlignText = typeof variant === 'string' && variant.toLowerCase().includes('centeraligntext');
    const isMobileGrid = typeof variant === 'string' && variant.toLowerCase().includes('mobilegrid');

    const promoGroup = promos.map((singlePromo, i) => {
      const { action, actionheading, alt, brandalt, brandid, brandsrc, copy, cta, gae, heading, promotag, src, subtext, url } = singlePromo;
      const isPopup = action === 'popup';
      const linkProps = {
        'onClick': onLandingComponentClick,
        'data-eventlabel': 'melodyPromoGroup',
        'data-eventvalue': gae || alt,
        'data-slotindex': slotIndex,
        'key': makeKey(url, i),
        'className': cn(css.promo, { [css.exactlyTwoPromos]: exactlyTwoPromos, [css.isCenterAlignText]: isCenterAlignText, [css.mobileGridPromo]: isMobileGrid })
      };

      const makeImage = () => {
        const imageProps = { src, alt, shouldLazyLoad, imgTestId: testId('melodyPromoContentImg') };
        const promoImg = <LandingPageImage {...imageProps} />;

        if (promotag || isPopup) {
          const testIdName = isPopup ? 'melodyPromoGroupProductReleaseContainer' : 'melodyPromoGroupPromoTag';

          return (<div className={css.imgContainer} data-test-id={testId(testIdName)}>
            {promotag && <p>{promotag}</p>}
            {promoImg}
          </div>);
        } else if (isMobileGrid) {
          return (
            <div className={css.mobileGridImageContainer}>
              <div className={css.mobileGridProductImage}>
                {promoImg}
              </div>
            </div>
          );
        } else {
          return promoImg;
        }
      };

      const contents = (
        <section key={makeKey(heading, i)}>
          {makeImage()}

          {brandid && <Modal
            isOpen={modalIndex === i}
            onRequestClose={this.toggleModal}
            contentLabel="ProductReleaseModal"
            overlayClassName={css.modalOverlay}
            className={css.modalContent}
            bodyOpenClassName={css.modalOpenBodyStyle}
            shouldCloseOnOverlayClick={true}>

            <button
              type="button"
              onClick={this.toggleModal}
              className={css.close}
              data-test-id={testId('closeModal')}
              aria-label="Close"
              data-eventlabel="closeButton"
              data-eventvalue={cta}/>

            <NotificationSignup
              toggleModal={this.toggleModal}
              onTaxonomyComponentClick={onLandingComponentClick}
              slotDetails={slotDetails}
              componentStyle="promoGroupModal"
              heading={actionheading || 'Shoe Release Reminder'}
              listId={brandid}
              id={brandid}
              imageUrl={src}
              alt={alt}
            />
          </Modal>}

          <section className={css.bottom}>
            {
              brandsrc && <div className={css.brandimg}><img src={brandsrc} alt={brandalt}/></div>
            }
            <div className={css.content}>
              {heading && <h3 data-test-id={testId('melodyPromoContentHeading')}>{heading}</h3>}
              {copy && <p className={css.copy}>{copy}</p>}
              {subtext && <p className={css.subtext}>{subtext}</p>}
              {action === 'popup' ? <button
                onClick={this.toggleModal}
                data-modal-index={i}
                className={css.cta}
                type="button"
                data-eventlabel={cta}
                data-eventvalue={gae || alt}
                data-test-id={testId('openModal')}>{cta}</button> : <p
                className={css.cta}
                data-test-id={testId('melodyPromoContentCta')}>{cta}</p>}
            </div>
          </section>
        </section>
      );

      if (isPopup) {
        return <div className={cn(css.promo, { [css.exactlyTwoPromos]: exactlyTwoPromos, [css.isCenterAlignText]: isCenterAlignText })} key={`${actionheading}_${brandid}`}>{contents}</div>;
      } else {
        return (
          <LandingPageLink
            key={url}
            url={url}
            fallbackNode="div"
            {...linkProps}
          >
            {contents}
          </LandingPageLink>
        );
      }
    });

    return (
      <div className={cn(css.promoGroupContainer, { [css.exactlyTwoPromos]: exactlyTwoPromos })} data-slot-id={slotName} data-monetate-id={monetateId}>
        {heading && <h2>{heading}</h2>}
        <div className={cn(css.promos, { [css.mobileGridPromoGroup]: isMobileGrid })}>
          {promoGroup}
        </div>
      </div>
    );
  }
}

MelodyPromoGroup.contextTypes = {
  testId: PropTypes.func
};

export default MelodyPromoGroup;
